import HcSticky from 'hc-sticky'
import log from 'salvo-lite/log'
class Sticky {
    constructor (theme, elem) {
        this._elem = elem
        this._top = document.querySelector('header').offsetHeight
        this._options = {
            top: this._top,
            bottomEnd: 50,
            innerTop: 0,
            followScroll: false,
            stickTo: elem.closest('.sticky-container') || elem.parentNode,
            ...JSON.parse(elem.dataset.sticky)
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        let Sticky = new HcSticky(this._elem, this._options)
        console.log(Sticky)
    }
}
export default Sticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Sticky.js